module.exports = __webpack_public_path__ + "static/img/near-expire-product-link.451e9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/near-expire-product-link.png
// module id = EqX0
// module chunks = 134